/* @generated from adl module totalinteraction.futurefit.lpapirequests */

import * as ADL from './../../runtime/adl';
import * as common_http from './../../common/http';
import * as totalinteraction_futurefit_lpapi from './lpapi';

export type EndPoint = string;

const EndPoint_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapirequests","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"EndPoint","version":{"kind":"nothing"}}};

export const snEndPoint: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapirequests", name:"EndPoint"};

export function texprEndPoint(): ADL.ATypeExpr<EndPoint> {
  return {value : {typeRef : {kind: "reference", value : snEndPoint}, parameters : []}};
}

/**
 * ISSUE: This is by no means generalizable - need to program this in at runtime
 */
export type GetCatalog = common_http.Get<totalinteraction_futurefit_lpapi.Catalog>;

const GetCatalog_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapirequests","decl":{"annotations":[{"v1":{"moduleName":"common.http","name":"Path"},"v2":"/courses"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"Get"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Catalog"}},"parameters":[]}]}}},"name":"GetCatalog","version":{"kind":"nothing"}}};

export const snGetCatalog: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapirequests", name:"GetCatalog"};

export function texprGetCatalog(): ADL.ATypeExpr<GetCatalog> {
  return {value : {typeRef : {kind: "reference", value : snGetCatalog}, parameters : []}};
}

export type GetUser = common_http.Get<totalinteraction_futurefit_lpapi.Users>;

const GetUser_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapirequests","decl":{"annotations":[{"v1":{"moduleName":"common.http","name":"Path"},"v2":"/users"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"Get"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Users"}},"parameters":[]}]}}},"name":"GetUser","version":{"kind":"nothing"}}};

export const snGetUser: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapirequests", name:"GetUser"};

export function texprGetUser(): ADL.ATypeExpr<GetUser> {
  return {value : {typeRef : {kind: "reference", value : snGetUser}, parameters : []}};
}

export type CreateUser = common_http.Post<totalinteraction_futurefit_lpapi.UserCreateReq, totalinteraction_futurefit_lpapi.User>;

const CreateUser_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapirequests","decl":{"annotations":[{"v1":{"moduleName":"common.http","name":"Path"},"v2":"/users"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"Post"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"UserCreateReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"User"}},"parameters":[]}]}}},"name":"CreateUser","version":{"kind":"nothing"}}};

export const snCreateUser: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapirequests", name:"CreateUser"};

export function texprCreateUser(): ADL.ATypeExpr<CreateUser> {
  return {value : {typeRef : {kind: "reference", value : snCreateUser}, parameters : []}};
}

export type GetEnrolment = common_http.Get<totalinteraction_futurefit_lpapi.Enrolments>;

const GetEnrolment_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapirequests","decl":{"annotations":[{"v1":{"moduleName":"common.http","name":"Path"},"v2":"/enrolments"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"Get"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Enrolments"}},"parameters":[]}]}}},"name":"GetEnrolment","version":{"kind":"nothing"}}};

export const snGetEnrolment: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapirequests", name:"GetEnrolment"};

export function texprGetEnrolment(): ADL.ATypeExpr<GetEnrolment> {
  return {value : {typeRef : {kind: "reference", value : snGetEnrolment}, parameters : []}};
}

export type CreateEnrolment = common_http.Post<totalinteraction_futurefit_lpapi.EnrolmentCreateReq, totalinteraction_futurefit_lpapi.Enrolment>;

const CreateEnrolment_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.lpapirequests","decl":{"annotations":[{"v1":{"moduleName":"common.http","name":"Path"},"v2":"/enrolments"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"Post"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"EnrolmentCreateReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.lpapi","name":"Enrolment"}},"parameters":[]}]}}},"name":"CreateEnrolment","version":{"kind":"nothing"}}};

export const snCreateEnrolment: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.lpapirequests", name:"CreateEnrolment"};

export function texprCreateEnrolment(): ADL.ATypeExpr<CreateEnrolment> {
  return {value : {typeRef : {kind: "reference", value : snCreateEnrolment}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "totalinteraction.futurefit.lpapirequests.EndPoint" : EndPoint_AST,
  "totalinteraction.futurefit.lpapirequests.GetCatalog" : GetCatalog_AST,
  "totalinteraction.futurefit.lpapirequests.GetUser" : GetUser_AST,
  "totalinteraction.futurefit.lpapirequests.CreateUser" : CreateUser_AST,
  "totalinteraction.futurefit.lpapirequests.GetEnrolment" : GetEnrolment_AST,
  "totalinteraction.futurefit.lpapirequests.CreateEnrolment" : CreateEnrolment_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/lpapirequests.ts